
const APIClient = class APIClient {
  // static myInstance = null;
  // static getInstance() {
  //   if (APIClient.myInstance == null) {
  //     APIClient.myInstance = new APIClient();
  //   }
  //   return this.myInstance;
  // }
  private static myInstance: APIClient | undefined;

  static getInstance() {
    if (APIClient.myInstance === undefined) {
      APIClient.myInstance = new APIClient();
    }
    return this.myInstance;
  }
  //////////////////////////////////////////////////////////----GET METHOD---////////////////////////////////////////////////////////////////////////////////////////////////////////////

  get(endpoint: any, data: any, UserToken: any) {
    return new Promise((resolve, reject) => {
      fetch(data ? `${endpoint + data}` : `${endpoint}`, {
        method: "GET",
        headers: {
          Authorization: UserToken,
        },
      })
        .then(async (res) => {
          let response = await res.json();
          if (!res.ok) {
            return reject(response);
          }
          return resolve(response);
        })
        .catch(reject);
    });
  }
  getCountryCodes(endpoint: any) {
    return new Promise((resolve, reject) => {
      fetch(`${endpoint}`, {
        method: "GET",
        headers: {
          Authorization: "1234",
        },
      })
        .then(async (res) => {
          let response = await res.json();
          if (!res.ok) {
            return reject(response);
          }
          return resolve(response);
        })
        .catch(reject);
    });
  }
  getGold(endpoint: any, token: any) {
    return new Promise((resolve, reject) => {
      fetch(`${endpoint}`, {
        method: "GET",
        headers: {
          Authorization: token,
        },
      })
        .then(async (res) => {
          let response = await res.json();
          if (!res.ok) {
            return reject(response);
          }
          return resolve(response);
        })
        .catch(reject);
    });
  }

  getRequest(endpoint: any, UserToken: any) {
    return new Promise((resolve, reject) => {
      fetch(`${endpoint}`, {
        method: "GET",
        headers: {
          Authorization: UserToken,
        },
      })
        .then(async (res) => {
          let response = await res.json();
          if (!res.ok) {
            return reject(response);
          }
          return resolve(response);
        })
        .catch(reject);
    });
  }

  //////////////////////////////////////////////////////////----POST METHOD---////////////////////////////////////////////////////////////////////////////////////////////////////////////

  post(endpoint: any, data: any, UserToken: any) {
    return new Promise((resolve, reject) => {
      fetch(`${endpoint}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: data,
      })
        .then((response) => response.json())
        .then((result) => {
          return resolve(result);
        })
        .catch((error) => {
          return reject(error);
        });
    });
  }

  postData(endpoint: any, data: any, UserToken: any) {
    console.log(data, "inside postData");
    return new Promise((resolve, reject) => {
      fetch(`${endpoint}`, {
        method: "POST",
        headers: {
          Authorization: UserToken,
          "Content-Type": "application/json",
        },
        body: data,
      })
        .then((response) => response.json())
        .then((result) => {
          return resolve(result);
        })
        .catch((error) => {
          return reject(error);
        });
    });
  }

  

  uploadData(endpoint: any, data: FormData, UserToken: any) {
    return new Promise((resolve, reject) => {
      fetch(`${endpoint}`, {
        method: "POST",
        headers: {
          Authorization: UserToken,
        },
        body: data,
      })
        .then((response) => response.json())
        .then((result) => {
          return resolve(result);
        })
        .catch((error) => {
          return reject(error);
        });
    });
  }

  delete(endpoint: any, data: any, UserToken: any) {
    return new Promise((resolve, reject) => {
      fetch(`${endpoint}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: UserToken,
        },
        body: data,
      })
        .then((response) => response.json())
        .then((result) => {
          return resolve(result);
        })
        .catch((error) => {
          return reject(error);
        });
    });
  }

  deleteById(endpoint: any, UserToken: any) {
    return new Promise((resolve, reject) => {
      fetch(`${endpoint}`, {
        method: "DELETE",
        headers: {
          Authorization: UserToken,
        },
      })
        .then((response) => response.json())
        .then((result) => {
          return resolve(result);
        })
        .catch((error) => {
          return reject(error);
        });
    });
  }
  getEncodedData = (parms: any) => {
    var formBody = new FormData();
    for (var property in parms) {
      formBody.append(property, `${parms[property]}`);
    }
    return formBody;
  };
};


export { APIClient };
